require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-john-shiver.json") })
        }
      }, "path---blog-author-john-shiver");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-john-shiver!./.cache/json/blog-author-john-shiver.json
// module id = 660
// module chunks = 231608221292675